import { render } from "./alarmComments.vue?vue&type=template&id=f7638102"
import script from "./alarmComments.vue?vue&type=script&lang=js"
export * from "./alarmComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__